export default __webpack_public_path__ + "static/media/maxcap-icon.cd3d3ccf.svg";